import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './authComponents/Login';
import Signup from './authComponents/Signup';
import PasswordReset from './authComponents/PasswordReset';
import ProtectedRoute from './components/ProtectedRoute';
import LinkCheckerDashboard from './pages/LinkCheckerDashboard';
import ConfigRunsPage from './pages/ConfigRunsPage';
import { setupAutoRefresh } from './utils/tokenRefresh';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [loadingAuth, setLoadingAuth] = useState<boolean>(true);

  useEffect(() => {
    const checkAuth = () => {
      const accessToken = localStorage.getItem('access_token');
      setIsAuthenticated(!!accessToken);
      setLoadingAuth(false);
      if (accessToken) {
        setupAutoRefresh();
      }
    };
    checkAuth();

    window.addEventListener('storage', checkAuth);
    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  if (loadingAuth) {
    return <div className="auth-shell">Loading authentication...</div>;
  }

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setupAutoRefresh();
  };

  const handleSignupSuccess = () => {
    setIsAuthenticated(true);
    setupAutoRefresh();
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/signup" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Signup onSignupSuccess={handleSignupSuccess} />} />
        <Route path="/request-password-reset" element={<PasswordReset />} />
        <Route path="/reset-password" element={<PasswordReset />} />

        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route path="/dashboard" element={<LinkCheckerDashboard />} />
          <Route path="/config/:configId/runs" element={<ConfigRunsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
